import TeacherProfileBox from './TeacherProfileBox';

export default TeacherProfileBox;
